import OneNews from "./OneNews/index";
import LoadedComponent from "./LoadedComponent/index";

import { useEffect } from "react";
import "./allnews.scss";
import { inject, observer } from "mobx-react";

const AllNews = ({
  token,
  news,
  allNewsCount,
  getNewsData,
  showMoreNews,
  isLoading,
  error,
  setSignInModal
}) => {
  useEffect(() => {
    getNewsData();
    !token && setSignInModal(true);
  }, []);

  return (
    <div className="allnews-wrapper">
      <div className="allnews">
        <LoadedComponent isLoading={isLoading} error={error}>
          {news.length
            ? news.map((onenews) => (
                <OneNews
                  header={onenews.title}
                  preview={(onenews.preview ?? "").replace(
                    /<\/?[^>]+(>|$)/g,
                    ""
                  )}
                  description={(onenews.content ?? "").replace(
                    /<\/?[^>]+(>|$)/g,
                    ""
                  )}
                  img={onenews.preview_url}
                  date={onenews.time_create}
                  id={onenews.id}
                  key={onenews.id}
                  onenews={onenews}
                />
              ))
            : ""}
          <button
            onClick={() => {
              showMoreNews();
            }}
            disabled={!token || news.length == allNewsCount}
            className="cards-map-button"
          >
            Показать еще
          </button>
        </LoadedComponent>
      </div>
    </div>
  );
};

export default inject(({ usersStore, modalWindows, newsStore }) => {
  const { token } = usersStore;
  const { setSignInModal } = modalWindows;

  const { news, allNewsCount, getNewsData, showMoreNews, isLoading, error } =
    newsStore;
  return {
    token,
    news,
    allNewsCount,
    getNewsData,
    showMoreNews,
    isLoading,
    error,

    setSignInModal
  };
})(observer(AllNews));
